<template>
  <v-card class="glass-section-card mb-6" elevation="0">
    <v-card-subtitle class="section-header d-flex align-center pb-2">
      <v-icon left color="primary">mdi-eye-outline</v-icon>
      <span class="text-subtitle-1 font-weight-bold">Postavke prikaza</span>
    </v-card-subtitle>
    <v-card-text>
      <v-row>
        <v-col cols="12" sm="6">
          <v-checkbox
            v-model="localSettings.show_images"
            label="Prikaži slike artikala"
            dense
            hide-details
            color="primary"
            @change="emitUpdate"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="6">
          <v-checkbox
            v-model="localSettings.show_descriptions"
            label="Prikaži opise"
            dense
            hide-details
            color="primary"
            @change="emitUpdate"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="6">
          <v-checkbox
            v-model="localSettings.show_allergens"
            label="Prikaži alergene/sastojke"
            dense
            hide-details
            color="primary"
            @change="emitUpdate"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="6">
          <v-checkbox
            v-model="localSettings.show_prices"
            label="Prikaži cijene"
            dense
            hide-details
            color="primary"
            @change="emitUpdate"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="6">
          <v-checkbox
            v-model="localSettings.clickable_items"
            label="Klikabilni artikli"
            dense
            hide-details
            color="primary"
            @change="emitUpdate"
          ></v-checkbox>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'DisplaySettings',
  props: {
    settings: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      localSettings: {
        show_images: true,
        show_descriptions: true,
        show_allergens: true,
        show_prices: true,
        clickable_items: false
      }
    }
  },
  watch: {
    settings: {
      handler (newSettings) {
        this.localSettings = {
          show_images: newSettings.show_images !== undefined ? newSettings.show_images : true,
          show_descriptions: newSettings.show_descriptions !== undefined ? newSettings.show_descriptions : true,
          show_allergens: newSettings.show_allergens !== undefined ? newSettings.show_allergens : true,
          show_prices: newSettings.show_prices !== undefined ? newSettings.show_prices : true,
          clickable_items: newSettings.clickable_items !== undefined ? newSettings.clickable_items : false
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    emitUpdate () {
      this.$emit('update:settings', this.localSettings)
    }
  }
}
</script>

<style scoped>
/* Reuse parent styles */
</style>
